module.exports = __webpack_public_path__ + "img/index_top.42126c39.png";